module.exports = __webpack_public_path__ + "static/img/banner.63eec42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner.png
// module id = 7E6U
// module chunks = 62